import React, {useState} from 'react';
import {
    Input,
    Button,
    Select,
    DatePicker,
    Switch,
    ConfigProvider,
    message,
    Row,
    Col,
    Card,
    Divider
} from 'antd';
import moment from "moment";
import locale from 'antd/lib/locale/ru_RU';
import s from './styles/staff.module.css';

const {Option} = Select;
const {TextArea} = Input;

const AddStaffForm = ({onAddStaff, onCancel}) => {
    const [loading, setLoading] = useState(false);

    // Основное состояние формы
    const [formData, setFormData] = useState({
        name: '',
        secondName: '',
        patronymic: '',
        nationality: '',
        birthdayDate: null,
        dateStartWork: null,
        passport: '',
        passportDate: null,
        boravok: '',
        boravokDate: null,
        driverLicense: '',
        driverLicenseDate: null,
        phone: '',
        email: '',
        address: '',
        contactFaceOne: '',
        contactFacePhoneOne: '',
        contactFaceTwo: '',
        contactFacePhoneTwo: '',
        exp: '',
        language: '',
        login: '',
        status: 1,
        workContract: false,
        workContractEnd: null
    });

    console.log(formData);

    // Состояния для переключателей
    const [hasPersonalCar, setHasPersonalCar] = useState(false);
    const [isGardener, setIsGardener] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isStoreManager, setIsStoreManager] = useState(false);
    const [hasStoreAccess, setHasStoreAccess] = useState(false);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleDateChange = (field, date) => {
        setFormData(prev => ({
            ...prev,
            [field]: date
        }));
    };

    // Функция для обработки ручного ввода даты
    const handleManualDateInput = (field, value) => {
        if (!value) {
            handleDateChange(field, null);
            return;
        }

        // Парсим дату в формате DD.MM.YYYY
        const dateParts = value.split('.');
        if (dateParts.length === 3) {
            const day = parseInt(dateParts[0], 10);
            const month = parseInt(dateParts[1], 10) - 1; // Месяцы в moment от 0 до 11
            const year = parseInt(dateParts[2], 10);

            if (day >= 1 && day <= 31 && month >= 0 && month <= 11 && year >= 1900) {
                const newDate = moment([year, month, day]);
                if (newDate.isValid()) {
                    handleDateChange(field, newDate);
                    return;
                }
            }
        }

        // Если дата невалидна, показываем сообщение
        message.warning('Неверный формат даты. Используйте DD.MM.YYYY');
    };

    // Новая функция для обработки изменения даты (объединяет оба способа ввода)
    const handleDateInput = (field, date, inputValue) => {
        // Если date есть - это выбор из календаря
        if (date) {
            handleDateChange(field, date);
        }
        // Если date нет, но есть inputValue - это ручной ввод
        else if (inputValue !== undefined) {
            handleManualDateInput(field, inputValue);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            console.log('Form data:', formData);

            // Функция для преобразования даты в Unix timestamp
            const dateToUnixMs = (date) => {
                return date ? moment(date).format('X') : null
            };

            const formattedData = {
                firstname: formData.name || "",
                lastname: formData.secondName || "",
                patronymic: formData.patronymic || "",
                store_id: 0,
                status: parseInt(formData.status) || 1,
                role: getRolesString(),
                login: formData.login || "",
                enable_store: hasStoreAccess ? 1 : 0,
                info: {
                    phone: formData.phone || "",
                    email: formData.email || "",
                    adress: formData.address || "",
                    nationality: formData.nationality || "",
                    contract: formData.workContract ? 1 : 0,
                    contract_fdate: dateToUnixMs(formData.workContractEnd),
                    first_parrent_name: formData.contactFaceOne || "",
                    first_parrent_phone: formData.contactFacePhoneOne || "",
                    second_parrent_name: formData.contactFaceTwo || "",
                    second_parrent_phone: formData.contactFacePhoneTwo || "",
                    birthday_date: dateToUnixMs(formData.birthdayDate),
                    work_start_date: dateToUnixMs(formData.dateStartWork),
                    passport: formData.passport || "",
                    passport_fdate: dateToUnixMs(formData.passportDate),
                    boravok: formData.boravok || "",
                    boravok_fdate: dateToUnixMs(formData.boravokDate),
                    driver_license: formData.driverLicense || "",
                    driver_license_fdate: dateToUnixMs(formData.driverLicenseDate),
                    kpi: 100,
                    language: formData.language || "",
                    exp: formData.exp || "",
                    personal_car: hasPersonalCar ? 1 : 0
                }
            };

            console.log('Formatted data to send:', formattedData);
            await onAddStaff(formattedData);
            message.success('Сотрудник успешно добавлен');
            resetForm();
        } catch (error) {
            console.error('Error adding staff:', error);
            message.error('Ошибка при добавлении сотрудника');
        } finally {
            setLoading(false);
        }
    };

    const getRolesString = () => {
        const roles = [];
        if (isGardener) roles.push('3');
        if (isAdmin) roles.push('1');
        if (isStoreManager) roles.push('6');
        return roles.join(',');
    };

    const resetForm = () => {
        setFormData({
            name: '',
            secondName: '',
            patronymic: '',
            nationality: '',
            birthdayDate: null,
            dateStartWork: null,
            passport: '',
            passportDate: null,
            boravok: '',
            boravokDate: null,
            driverLicense: '',
            driverLicenseDate: null,
            phone: '',
            email: '',
            address: '',
            contactFaceOne: '',
            contactFacePhoneOne: '',
            contactFaceTwo: '',
            contactFacePhoneTwo: '',
            exp: '',
            language: '',
            login: '',
            status: '1',
            workContract: false,
            workContractEnd: null
        });
        setHasPersonalCar(false);
        setIsGardener(false);
        setIsAdmin(false);
        setIsStoreManager(false);
        setHasStoreAccess(false);
    };

    return (
        <div className={s.addStaffCont} style={{
            overflow: 'hidden',
            height: '100%',
            padding: '16px 8px 20px'
        }}>

            <h2 style={{textAlign: 'center', marginBottom: 24}}>Добавление нового сотрудника</h2>

            <div>
                {/* Основные данные */}
                <Card title="Основные данные" style={{marginBottom: 16}} size="small">
                    <Row gutter={[12, 8]}>
                        <Col span={24} md={8}>
                            <div style={{marginBottom: 12}}>
                                <label>Фамилия</label>
                                <Input
                                    value={formData.secondName}
                                    onChange={(e) => handleInputChange('secondName', e.target.value)}
                                    placeholder="Введите фамилию"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={8}>
                            <div style={{marginBottom: 12}}>
                                <label>Имя *</label>
                                <Input
                                    value={formData.name}
                                    onChange={(e) => handleInputChange('name', e.target.value)}
                                    placeholder="Введите имя"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={8}>
                            <div style={{marginBottom: 12}}>
                                <label>Отчество</label>
                                <Input
                                    value={formData.patronymic}
                                    onChange={(e) => handleInputChange('patronymic', e.target.value)}
                                    placeholder="Введите отчество"
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[12, 8]}>
                        <Col span={24} md={8}>
                            <div style={{marginBottom: 12}}>
                                <label>Гражданство</label>
                                <Input
                                    value={formData.nationality}
                                    onChange={(e) => handleInputChange('nationality', e.target.value)}
                                    placeholder="Введите гражданство"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={8}>
                            <div style={{marginBottom: 12}}>
                                <label>Дата рождения</label>
                                <ConfigProvider locale={locale}>
                                    <DatePicker
                                        style={{width: '100%'}}
                                        value={formData.birthdayDate}
                                        onChange={(date, dateString) => handleDateInput('birthdayDate', date, dateString)}
                                        format="DD.MM.YYYY"
                                        placeholder="DD.MM.YYYY"
                                        allowClear
                                    />
                                </ConfigProvider>
                            </div>
                        </Col>
                        <Col span={24} md={8}>
                            <div style={{marginBottom: 12}}>
                                <label>Дата начала работы</label>
                                <ConfigProvider locale={locale}>
                                    <DatePicker
                                        style={{width: '100%'}}
                                        value={formData.dateStartWork}
                                        onChange={(date, dateString) => handleDateInput('dateStartWork', date, dateString)}
                                        format="DD.MM.YYYY"
                                        placeholder="DD.MM.YYYY"
                                        allowClear
                                    />
                                </ConfigProvider>
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Документы */}
                <Card title="Документы" style={{marginBottom: 16}} size="small">
                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Паспорт</label>
                                <Input
                                    value={formData.passport}
                                    onChange={(e) => handleInputChange('passport', e.target.value)}
                                    placeholder="Номер паспорта"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Срок действия паспорта</label>
                                <ConfigProvider locale={locale}>
                                    <DatePicker
                                        style={{width: '100%'}}
                                        value={formData.passportDate}
                                        onChange={(date, dateString) => handleDateInput('passportDate', date, dateString)}
                                        format="DD.MM.YYYY"
                                        placeholder="DD.MM.YYYY"
                                        allowClear
                                    />
                                </ConfigProvider>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Боравок</label>
                                <Input
                                    value={formData.boravok}
                                    onChange={(e) => handleInputChange('boravok', e.target.value)}
                                    placeholder="Номер боравка"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Срок действия боравка</label>
                                <ConfigProvider locale={locale}>
                                    <DatePicker
                                        style={{width: '100%'}}
                                        value={formData.boravokDate}
                                        onChange={(date, dateString) => handleDateInput('boravokDate', date, dateString)}
                                        format="DD.MM.YYYY"
                                        placeholder="DD.MM.YYYY"
                                        allowClear
                                    />
                                </ConfigProvider>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Водительское удостоверение</label>
                                <Input
                                    value={formData.driverLicense}
                                    onChange={(e) => handleInputChange('driverLicense', e.target.value)}
                                    placeholder="Номер ВУ"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Срок действия ВУ</label>
                                <ConfigProvider locale={locale}>
                                    <DatePicker
                                        style={{width: '100%'}}
                                        value={formData.driverLicenseDate}
                                        onChange={(date, dateString) => handleDateInput('driverLicenseDate', date, dateString)}
                                        format="DD.MM.YYYY"
                                        placeholder="DD.MM.YYYY"
                                        allowClear
                                    />
                                </ConfigProvider>
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Контакты */}
                <Card title="Контакты" style={{marginBottom: 16}} size="small">
                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Телефон</label>
                                <Input
                                    value={formData.phone}
                                    onChange={(e) => handleInputChange('phone', e.target.value)}
                                    placeholder="Номер телефона"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Email</label>
                                <Input
                                    type="email"
                                    value={formData.email}
                                    onChange={(e) => handleInputChange('email', e.target.value)}
                                    placeholder="Email адрес"
                                />
                            </div>
                        </Col>
                    </Row>

                    <div style={{marginBottom: 12}}>
                        <label>Адрес</label>
                        <TextArea
                            rows={2}
                            value={formData.address}
                            onChange={(e) => handleInputChange('address', e.target.value)}
                            placeholder="Полный адрес"
                        />
                    </div>

                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Контактное лицо 1</label>
                                <Input
                                    value={formData.contactFaceOne}
                                    onChange={(e) => handleInputChange('contactFaceOne', e.target.value)}
                                    placeholder="Имя контактного лица"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Телефон контактного лица 1</label>
                                <Input
                                    value={formData.contactFacePhoneOne}
                                    onChange={(e) => handleInputChange('contactFacePhoneOne', e.target.value)}
                                    placeholder="Номер телефона"
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Контактное лицо 2</label>
                                <Input
                                    value={formData.contactFaceTwo}
                                    onChange={(e) => handleInputChange('contactFaceTwo', e.target.value)}
                                    placeholder="Имя контактного лица"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Телефон контактного лица 2</label>
                                <Input
                                    value={formData.contactFacePhoneTwo}
                                    onChange={(e) => handleInputChange('contactFacePhoneTwo', e.target.value)}
                                    placeholder="Номер телефона"
                                />
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Роли и доступы */}
                <Card title="Роли и доступы" style={{marginBottom: 16}} size="small">
                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Опыт работы</label>
                                <TextArea
                                    rows={2}
                                    value={formData.exp}
                                    onChange={(e) => handleInputChange('exp', e.target.value)}
                                    placeholder="Опыт работы"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Владение языками</label>
                                <Input
                                    value={formData.language}
                                    onChange={(e) => handleInputChange('language', e.target.value)}
                                    placeholder="Языки"
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[12, 8]}>
                        <Col span={24} md={8}>
                            <div style={{marginBottom: 12}}>
                                <label>Личный транспорт</label>
                                <div>
                                    <Switch
                                        checked={hasPersonalCar}
                                        onChange={setHasPersonalCar}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Divider/>

                    <Row gutter={[12, 8]}>
                        <Col span={12} md={6}>
                            <div style={{marginBottom: 12}}>
                                <label>Садовник</label>
                                <div>
                                    <Switch
                                        checked={isGardener}
                                        onChange={setIsGardener}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col span={12} md={6}>
                            <div style={{marginBottom: 12}}>
                                <label>Администратор</label>
                                <div>
                                    <Switch
                                        checked={isAdmin}
                                        onChange={setIsAdmin}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col span={12} md={6}>
                            <div style={{marginBottom: 12}}>
                                <label>Менеджер склада</label>
                                <div>
                                    <Switch
                                        checked={isStoreManager}
                                        onChange={setIsStoreManager}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col span={12} md={6}>
                            <div style={{marginBottom: 12}}>
                                <label>Доступ к складу</label>
                                <div>
                                    <Switch
                                        checked={hasStoreAccess}
                                        onChange={setHasStoreAccess}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[12, 8]}>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Логин</label>
                                <Input
                                    value={formData.login}
                                    onChange={(e) => handleInputChange('login', e.target.value)}
                                    placeholder="Логин пользователя"
                                />
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <div style={{marginBottom: 12}}>
                                <label>Статус</label>
                                <Select
                                    value={formData.status}
                                    onChange={(value) => handleInputChange('status', value)}
                                    style={{width: '100%'}}
                                >
                                    <Option value={0}>Внештатный сотрудник</Option>
                                    <Option value={1}>Дневница</Option>
                                    <Option value={2}>Стажер</Option>
                                    <Option value={3}>Сотрудник</Option>
                                </Select>
                            </div>
                        </Col>
                    </Row>
                </Card>

                <div style={{textAlign: 'center', marginTop: 24}}>
                    <Button
                        type="primary"
                        onClick={handleSubmit}
                        loading={loading}
                        size="large"
                        style={{marginRight: 16, minWidth: 180}}
                        disabled={!formData.name} // Обязательное поле
                    >
                        Добавить сотрудника
                    </Button>
                    <Button onClick={onCancel} size="large" style={{minWidth: 100}}>
                        Отмена
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AddStaffForm;